// extracted by mini-css-extract-plugin
export default {"noNetworkContainer":"NoNetworkScreen_noNetworkContainer__PXpiO","icon":"NoNetworkScreen_icon__7-NeM"};